// trello-container-modal.component.ts
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RequestOptions, Headers, Response, Http } from '@angular/http';
import { ItemBean } from '../../../beansts/item.bean';
import { SpacialBean } from '../../../beansts/spacial.bean';
import { TranslationService } from '../../../services/translation.service';
import { AppDataService } from '../../../services/app-data.service';
import { UserService } from "../../../services/user.service";
import { CompanyService } from '../../../services/company.service';
import { WalletService } from '../../../services/wallet.services';
import { Door } from '../../../beansts/itens/door.bean';
import { NotificationBean } from '../../../beansts';

declare var $: any;
declare var Swal: any
declare let solanaWeb3: any
@Component({
  selector: 'trello-container-modal',
  templateUrl: 'trello-container-modal.html',
  providers: [],
})
export class TrelloContainerModal implements OnInit {
  public list;
  public containerList;
  public itemGroupList;
  public container = null;
  public ground = false;
  public groundList;
  public groundName = 'Chão';
  public containerImg = '/assets/game-ui/bag/bag.png'

  public nfts;
  public pubKey = null
  public connection;

  public tell = false;
  public paint;
  public equipChanged = {};
  public containerName = 'Container';
  public title = 'Clique para usar'

  public ctx;
  public canvas;

  public recipe;

  public mode = 1;
  public voidImage
  public MAXQUANTITY = 10;
  public gender = 'male';
  public skin = 'rgb(255, 0, 0,.2)';
  public shirt = 'rgb(255, 0, 0,.6)';
  public pants = 'rgb(0, 0, 255,.2)';
  public head = 'rgb(0, 0, 0,1)'
  public shoes = 'rgb(0, 0, 0,1)';
  public bodyTypeUrl
  public headTypeUrl
  public chestTypeUrl
  public legsTypeUrl
  public feetTypeUrl
  public bufferImage;
  public bufferName;
  public avatar;
  public admin = true;
  public allLoaded = false;
  public wallet
  public trelloSpec;
  public totalPages
  cardThumbnails: any;
  @Input() trelloCards: any[];
  @Input() selectedBoardId: string = '';
  @Input() selectedListId: string = '';
  public ngOnInit(): any {
    this.list = new Array(25).fill({ 'name': this.translate.instant('CONTAINER_MODAL_14'), thumbnail: '/assets/avatars/black.png', quantity: 0 })
    this.containerList = new Array(25).fill({ 'name': this.translate.instant('CONTAINER_MODAL_14'), thumbnail: '/assets/avatars/black.png', quantity: 0 })


    if (!this._appData.userEventContainer) {
      this._companyService.getUserContainerRef().get().then((cdata) => {
        let clist = [];
        cdata.forEach(c => {
          let item = new ItemBean();
          item.parse(c.data())
          clist.push(item)
        })
        this._appData.userEventContainer = clist;
      })

    }
  }


  public clickItem(item): void {
    Swal.fire({
      title: this.translate.instant('CONTAINER_MODAL_23'),
      icon: "warning",
      showConfirmButton: false,
      showCloseButton: true,
      html: `
        <p>O que você deseja fazer?</p>
        <div>
          <button id="itemUseClick" class="btn btn-primary">Utilizar</button>
          <button id="itemShareClick" class="btn btn-danger">Compartilhar</button>
          <button id="itemGroundClick" class="btn btn-secondary">Pro chão</button>
        </div>`
    });

    $(document).on('click', '#itemUseClick', () => {
      Swal.close();
      this._companyService.openExternalLink(item.url, null)

    });

    $(document).on('click', '#itemShareClick', () => {
      Swal.close();
      if (item.action == "room") {
        Swal.fire({ title: this.translate.instant('FAIL'), text: this.translate.instant('CONTAINER_MODAL_24') });
        return;
      }
      let date = new Date();
      let time = date.getTime();
      let name = this._appData.instagramUser.full_name;
      let notification = {
        event: this._appData.event.id,
        time: time,
        senderUid: this._appData.instagramUser.uid,
        senderName: name,
        senderThumbnail: '',
        subject: this.translate.instant('CONTAINER_MODAL_25'),
        message: name + this.translate.instant('CONTAINER_MODAL_26'),
        kind: 'seeLink',
        link: item.url,
        read: false,
        action: '',
        answer: ''
      };

      if (this._appData.page == 'meeting') {
        this._companyService.addRoomNotification(this._appData.room, notification);
      } else {
        if (this._appData.localConference) {
          this._appData.localConference.forEach(element => {
            if (element.uid == this._appData.instagramUser.uid) {
              Swal.fire({
                title: this.translate.instant('CONTAINER_MODAL_27'),
                text: this.translate.instant('CONTAINER_MODAL_28'),
                confirmButtonText: this.translate.instant('YES'),
                cancelButtonText: this.translate.instant('NO'),
                showCancelButton: true,
                showCloseButton: true,
              }).then((result) => {
                if (result.value) {
                  // abrir celular no espaço
                  this._companyService.openExternalLink(notification.link, false);
                }
              });
            } else {
              this._companyService.sendNotificationToSomeoneElse(
                this._appData.event,
                this._appData.instagramUser,
                element,
                notification.subject,
                notification.message,
                'seeLink',
                notification.link,
                false
              );
            }
          });
        } else {
          this.sendIframeMessage({ "kind": "shareItemToUsers", "item": item }, 'gameFrame');
        }
      }
    });

    $(document).on('click', '#itemGroundClick', () => {
      Swal.close();

      this.removeItem(item);
    });
  }
  public removeItem(item) {

    let myspace = this._appData.instagramUser.space;
    //ask position
    this.sendIframeMessage({ "kind": "getPosition" }, 'gameFrame')
    Swal.fire({
      title: this.translate.instant('CONTAINER_MODAL_32'),
      text: this.translate.instant('CONTAINER_MODAL_33'),
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText: this.translate.instant('NO'),
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
    }).then((result) => {
      if (result.dismiss == 'backdrop') { }
      else if (result.dismiss == 'close') { }
      else if (result.dismiss == 'cancel') { }
      else if (!result) { }
      else if (result.value) {
        let lpItem = new ItemBean();
        lpItem.name = item.name;
        lpItem.objectId = item.id;
        lpItem.thumbnail = item.texture;
        lpItem.triggers={onClick:[],onClose:[],onGrab:[]}
        lpItem.triggers['onClick'].push({
          kind:'openLink',
          param:{link:item.url}
        })
        lpItem.triggers['onGrab'].push({
          kind:'containable',
          param:{
            distance: 2,
            trelloId: item.id,
            listId: this._appData.object.objectId,
            itens:[]
          }
        })
        lpItem.owner = this._appData.instagramUser.uid;
        lpItem.static=true;
        lpItem.position = new SpacialBean()
        if (this._appData.instagramUser.position.x) {
          if ((this._appData.instagramUser.position.x - this._appData.room.defaultPlace.x) > 500) {
            lpItem.position.x = this._appData.room.defaultPlace.x
            lpItem.position.y = this._appData.room.defaultPlace.y
            lpItem.position.z = 0
          }
          else {
            lpItem.position.x = this._appData.instagramUser.position.x+1
            lpItem.position.y = this._appData.instagramUser.position.y+1
            lpItem.position.z = 0
          }
        }
        else {
          lpItem.position.x = this._appData.room.defaultPlace.x
          lpItem.position.y = this._appData.room.defaultPlace.y
          lpItem.position.z = 0

        }
        lpItem.space = myspace
        lpItem.dimension = new SpacialBean()
        lpItem.dimension.x = 0.5
        lpItem.dimension.y = 0.5
        lpItem.dimension.z = 0.5

        if (!lpItem.masterpiece) {
          //put item on room database
          lpItem.room = this._appData.room.id;
          lpItem.location = 'ground';
          //change card from trello position
          ///TODO
          this._companyService.moveTrelloCardToList(lpItem, this._appData.room.trello.list, 'roomObjects', 'add');
          this._companyService.getUserRoomItemRef(this._appData.room.id).doc(lpItem.objectId).set(lpItem.toDB());

        }
        else {
          Swal.fire({ title: this.translate.instant('FAIL'), text: this.translate.instant('CONTAINER_MODAL_34') })
        }



      }
    })
  }

  public change() {
    console.log('Change function started');
    if (!this.trelloSpec) {
      this._companyService.getCompanyTrelloSpecs(this._appData.company.dbId).get().then(v => {
        this.trelloSpec = v.data();
        this.fetchTrelloCards();

      })

    }
    else {
      this.fetchTrelloCards();
    }

    this.list = new Array(25).fill({
      'name': this.translate.instant('CONTAINER_MODAL_14'),
      thumbnail: '/assets/avatars/black.png',
      quantity: 0
    });

    this.sendIframeMessage({ kind: 'getPosition', params: '' }, 'gameFrame');

  }

  public fetchTrelloCards(showAll: boolean = true): void {
    console.log('Inside fetchTrelloCards');

    const apiUrlCards = 'https://us-central1-coolkids-669fa.cloudfunctions.net/getListCards?companyId=' +
      this._appData.company.dbId + '&listId=' + this._appData.object.objectId;

    this.http.get(apiUrlCards).subscribe(
      (responseCards: any) => {
        try {
          const trelloCards = responseCards.json();
          console.log('Resposta do Trello:', trelloCards);

          if (trelloCards && Array.isArray(trelloCards)) {
            this.list = [];
            let qtd = 0;
            trelloCards.forEach((card) => {

              // Define thumbnail
              let thumbnail = '';
              let icon = '';
              if (card.labels && card.labels.length > 0) {
                let label = card.labels[0].id;
                if (this.trelloSpec.cards[label]) {
                  thumbnail = this.trelloSpec.cards[label].thumbnail;
                  icon = this.trelloSpec.cards[label].icon;
                }
              }

              const thumbnailUrl = 'https://i.pinimg.com/564x/38/73/b1/3873b1b4febd838353c6542ba83f6a92.jpg';
              console.log('Thumbnail URL:', thumbnailUrl);
              this.list.push({
                id: card.id,
                name: card.name || 'Nome do Card Não Disponível',
                thumbnail: icon,
                texture: thumbnail,
                quantity: 1,
                url: card.url,
                assignedToMe: card.idMembers.includes(this._appData.instagramUser.trelloId)
              });
              qtd++;
            });

            // Adicionar cards fictícios para preencher a lista
            while (qtd < 24) {
              this.list.push({
                'name': this.translate.instant('CONTAINER_MODAL_14'),
                thumbnail: '/assets/avatars/black.png',
                quantity: 0
              });
              qtd++;
            }

            console.log('this.list after loop:', this.list);
          } else {
            console.error('A resposta do Trello não é um array válido:', trelloCards);
          }

          if (!showAll) {
            this.showMyCards();
          }
        } catch (error) {
          console.error('Erro ao processar os cards do Trello:', error);
        }
      },
      (error) => {
        console.error('Erro ao carregar os cards do Trello:', error);
      }
    );
  }

  public showMyCards(): void {
    const memberId = this._appData.instagramUser.trelloId;

    // Filtrar os cards atribuídos a você
    this.list = this.list.filter(card => {
      const assignedToMe = card.assignedToMe;
      if (assignedToMe) {
        console.log(`Card ID: ${card.id}, Member ID: ${memberId}`);
        card.memberID = memberId;

      }
      return assignedToMe;
    });
    while (this.list.length < 24) {
      this.list.push({
        'name': this.translate.instant('CONTAINER_MODAL_14'),
        thumbnail: '/assets/avatars/black.png',
        quantity: 0
      });
    }
  }

  public showAllCards(): void {
    this.fetchTrelloCards(true);

  }


  // Variáveis e funções para controle de navegação entre páginas
  public currentPage: number = 1;
  public itemsPerPage: number = 24;

  // Retorna os itens a serem exibidos na página atual
  public listToDisplay() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = Math.min(startIndex + this.itemsPerPage, this.list.length);
    return this.list.slice(startIndex, endIndex);
  }

  // Retorna um array com o número total de páginas
  public totalPagesArray() {
    if (!this.list){
      this.list=[]
    }
      return Array(Math.ceil(this.list.length / this.itemsPerPage)).fill(0).map((x, i) => i + 1);
  }

  // Navega para uma página específica
  public goToPage(page: number) {
    this.currentPage = page;
  }

  // Navega para a página anterior
  public prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  // Navega para a próxima página
  public nextPage() {
    if (this.currentPage < this.totalPagesArray().length) {
      this.currentPage++;
    }
  }

  public createItemFromNFT(newnft) {
    let item = new ItemBean();
    item.quantity = 1;
    item.name = newnft.name
    item.thumbnail = newnft.image
    item.owner = this._appData.instagramUser.uid;
    item.objectId = newnft.mint;
    item.description = newnft.description
    item.masterpiece = true;

    if (item.src) {
      //pattern for terrain: "https://sojustica-11662.firebaseio.com/nfts/1658368951231.json"
      //pattern for building:
      //pattern for recipe:
      let idx = item.src.indexOf('EHEZapCQKxhBBuRRLFnssNQbCaVHv2XR7LAEryLx5ENc')//building
      if (idx > 0) {
        item.tokenId = 'EHEZapCQKxhBBuRRLFnssNQbCaVHv2XR7LAEryLx5ENc'
        item.action = 'terrain'
      }
      else {
        item.action = 'terrain'
        item.masterpiece = true;
        item.tokenId = '9JQWPtZtNfsoHK1764ZX9oQHR9Q8hJ7MCSjr5ybW6pWP'
      }
      item.masterpiece = true;

    }

    return item

  }
  constructor(public _appData: AppDataService, public translate: TranslationService, public _companyService: CompanyService, public _walletService: WalletService, public _auth: UserService, public http: Http,
  ) {
  }

  public resetItemList() {
    //      this.list = new Array(25).fill({'name':'vazio',thumbnail:'/assets/avatars/black.png',quantity:0})
    let i = 0;
    this._appData.userEventContainer.forEach(val => {
      if (!val.quantity) { val.quantity = 1; }
      if (val.equipped) {
        if (val.where == 'legs') {
          this.legsTypeUrl = val
          this.getImage(val.src, val.objectId);
        }
        if (val.where == 'chest') {
          this.chestTypeUrl = val
          this.getImage(val.src, val.objectId);

        }
        if (val.where == 'feet') {
          this.feetTypeUrl = val
          this.getImage(val.src, val.objectId);
        }
        if (val.where == 'head') {
          this.headTypeUrl = val
          this.getImage(val.src, val.objectId);
        }

      }
    })

  }

  public redraw() {
    let canvas
    let ctx
    let mergedImages = [];
    if (!this.ctx) {
      this.canvas = $("#containerSpritesheet").get(0);
      this.ctx = this.canvas.getContext("2d");
    }
    ctx = this.ctx;
    canvas = this.canvas;

    // start over
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    //body
    let img = this.getImage(this.bodyTypeUrl, 'BODY')
    if (img == null) return false;
    this.drawImage(ctx, img, this.skin)

    let src = null;
    if (this.headTypeUrl) {
      src = this.headTypeUrl.src;
      img = this.getImage(src, this.headTypeUrl.objectId)
      if (img == null) return false;
      this.drawImage(ctx, img, this.headTypeUrl.color)
    }
    if (this.chestTypeUrl) {
      src = this.chestTypeUrl.src
      img = this.getImage(src, this.chestTypeUrl.objectId)
      if (img == null) return false;
      this.drawImage(ctx, img, this.chestTypeUrl.color)
    }
    if (this.legsTypeUrl) {
      src = this.legsTypeUrl.src
      img = this.getImage(src, this.legsTypeUrl.objectId)
      if (img == null) return false;
      this.drawImage(ctx, img, this.legsTypeUrl.color)
    }
    if (this.feetTypeUrl) {
      src = this.feetTypeUrl.src
      img = this.getImage(src, this.feetTypeUrl.objectId)
      if (img == null) return false;
      this.drawImage(ctx, img, this.feetTypeUrl.color)
    }
    this.tell = true;
    return true;
  }
  public confirmImages(shouldSave) {
    let confirmed = true;
    let img = this.getImage(this.bodyTypeUrl, 'BODY')
    if (img == null) confirmed = false;
    this._appData.userEventContainer.forEach(element => {
      if (element.action == 'equip' && element.src) {
        img = this.getImage(element.src, element.objectId)
        if (img == null) confirmed = false;
      }
    });
    if (!confirmed) {
      setTimeout(() => this.confirmImages(shouldSave), 3000)
    }
    else {
      if (!this.allLoaded) {
        this.allLoaded = true;
        console.log('Imagem carregada', 'Imagens de equipaveis carregados')
      }
      if (shouldSave) {
        this.saveNewStyle(false)
        Swal.fire(this.translate.instant('CONTAINER_MODAL_10'), this.translate.instant('CONTAINER_MODAL_11'))
        setTimeout(() => this.saveNewStyle(true), 3000)
      }
    }
  }
  public getImage(imgRef, imgId) {
    if (this._appData.images[imgId])
      return this._appData.images[imgId];
    else {
      // Load image if not in cache
      var img = new Image();
      img.src = imgRef;
      img.onload = () => {
        this._appData.images[imgId] = img;
      }
      return null;
    }
  }
  public getImage2(imgRef, callback) {
    if (this._appData.images[imgRef]) {
      callback(this._appData.images[imgRef]);
      return this._appData.images[imgRef];
    } else {

      // Load image if not in cache
      var img = new Image();
      img.src = imgRef;
      img.onload = function () { callback(img) };
      this._appData.images[imgRef] = img;
      return img;
    }
  }

  // Do not stop running all javascript if image not available
  public drawImage(ctx, img, color) {
    try {
      img.setAttribute('crossorigin', 'anonymous');

      let bcanvas = $("#buffer").get(0);
      bcanvas.style.visibility = 'hidden'
      bcanvas.width = 1008
      bcanvas.height = 1360
      let bctx = bcanvas.getContext("2d");
      bctx.globalCompositeOperation = 'source-over';
      bctx.drawImage(img, 0, 0);
      bctx.globalCompositeOperation = 'source-atop';
      bctx.fillStyle = color;
      bctx.fillRect(0, 0, bcanvas.width, bcanvas.height);

      ctx.globalCompositeOperation = 'source-over';
      ctx.drawImage(bcanvas, 0, 0, bcanvas.width, bcanvas.height, 0, 0, bcanvas.width, bcanvas.height);

    } catch (err) {
      console.error("Error: could not find " + img.src + err);
    }
  }
  public saveNewStyle(save) {
    //update user on game and on database
    if (!this.canvas) {
      this.canvas = $("#containerSpritesheet").get(0);
      this.ctx = this.canvas.getContext("2d");
    }
    this.canvas.style.visibility = 'visible'
    this.canvas.width = 1008
    this.canvas.height = 1360
    let drawed = this.redraw();
    if (drawed) {

      if (save) {
        var dataurl = this.canvas.toDataURL("image/png")
        let filename: string = 'avatar.png';

        var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        let pngFile = new File([u8arr], filename, { type: "image/png" });
        this._auth.uploadToFirebase(pngFile, filename, 'userprofile/' + this._appData.instagramUser.uid + '/avatar').subscribe(snapshot => {
          snapshot.ref.getDownloadURL().then(url => {
            this.sendIframeMessage({ kind: 'updateUserStatus', params: { avatar: url } }, 'gameFrame')
            this._companyService.updateUserProperty("avatar", url, this._appData.instagramUser)
            if (this.equipChanged) {
              for (let prop in this.equipChanged) {
                let val = this.equipChanged[prop]
                this._companyService.getUserContainerRef().doc(val.objectId).set(val.toDB());
              }
              this.equipChanged = null;
            }
            this._appData.instagramUser.avatar = url;
            //            window.location.reload()
          })

        });
      }
    }
  }
  public sendIframeMessage(messageKind, frame) {
    var iframe = document.getElementById(frame);
    if (iframe == null) return;
    var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
    iWindow.postMessage(messageKind, "*");
  }
  public swap() {
    if (this.mode == 3 || this.mode == 2) {
      this.containerImg = this.bufferImage;
      this.containerName = this.bufferName;
      this.mode = 1
    }
    else {
      this.containerImg = '/assets/game-ui/bag/bag.png'
      this.containerName = this.translate.instant('WALLET')
      this.mode = 3
    }
  }
  public makeMyWallet() {
    this._walletService.getCreateWallet('user', this._appData.instagramUser.uid).subscribe(val => {
      if (val.status == 200) {
        this.wallet = true;
        this.change();
      }
      else {
        this.wallet = false;
      }
    })
  }

  public equipItem(item) {
    let myitens = this._appData.userEventContainer;
    let itemToUnequip;
    //make sure i have my body and head on memory
    //basis collected
    switch (item.where) {
      case "chest": {
        itemToUnequip = this.chestTypeUrl;
        this.chestTypeUrl = item;
        break;
      }
      case "legs": {
        itemToUnequip = this.legsTypeUrl;
        this.legsTypeUrl = item;
        break;
      }
      case "feet": {
        itemToUnequip = this.feetTypeUrl;
        this.feetTypeUrl = item;
        break;
      }
      case "head": {
        itemToUnequip = this.headTypeUrl;
        this.headTypeUrl = item;
        break;
      }
    }
    if (!this.equipChanged) this.equipChanged = {}
    for (let idx = 0; idx < myitens.length; idx++) {//para cada item no meu inventory
      if (itemToUnequip) {//se eu tiver desequipado um item
        if (myitens[idx].objectId == itemToUnequip.objectId) {//se o item sendo visto é o item desequipado
          //removeit
          myitens[idx].equipped = false;
          this._companyService.getUserContainerRef().doc(myitens[idx].objectId).set(myitens[idx].toDB());
        }
      }
      if (myitens[idx].objectId == item.objectId) {//adicionar item
        myitens[idx].equipped = true;
        this._companyService.getUserContainerRef().doc(myitens[idx].objectId).set(myitens[idx].toDB());
      }

    }
    for (let id = 0; id < this.itemGroupList.length; id++) {
      let gitem = this.itemGroupList[id]
      if (gitem.objectId == item.objectId) {
        if (itemToUnequip) {
          this.itemGroupList[id] = itemToUnequip
        }
        else {
          this.itemGroupList[id] = { 'name': this.translate.instant('CONTAINER_MODAL_14'), thumbnail: '/assets/avatars/black.png', quantity: 0 }
        }
      }
    }
    this._appData.userEventContainer = myitens;
    this.resetItemList();
    this.confirmImages(true);
  }
  public drawEquipedItem() {
    this.equipChanged = false;
    if (!this._appData.images) {
      this._appData.images = {}
    }

    this.saveNewStyle(true);

  }
  public clickContainerItem(item) {
    //take item out of inventory to the container
    if (item.action == 'equip') {
      this.getImage(item.src, item.objectId);
    }
    this._companyService.removeFromContainer(this.container, item).then(val => {
      this.containerList = this.containerList.filter((it) => {
        return (item.objectId != it.objectId)
      })
    })
    this._companyService.addToUserContainer(this._appData.instagramUser, item.toDB()).then(val => {
      this.list.unshift(item)
      this._appData.userEventContainer = this.list;
      this.confirmImages(false);
    })

  }


  public reload(idx) {
    if (idx == 2) {
      this.mode = 2;
      let item = this._appData.object;
      this.itemGroupList = new Array(25).fill({ 'name': this.translate.instant('CONTAINER_MODAL_14'), thumbnail: '/assets/avatars/black.png', quantity: 0 })
      let lastIndex = 0
      this._companyService.getUserContainerRef().where('tokenId', '==', item.tokenId).get().then(v => {
        v.forEach(itD => {
          let it = itD.data();
          if (!it.equipped && it.location != 'ground') {
            let item = new ItemBean();
            item.parse(it);
            this.itemGroupList[lastIndex] = item;
            lastIndex = lastIndex + 1;
          }
        })
      })
    }
  }
  public useItem(item) {


    switch (item.action) {
      case "link": {
        this._companyService.openExternalLink(item.param.link, true);
        break
      }
      case "terrain": {
        let room = '';
        if (item.param) {
          room = item.param.room
        }
        if (item.properties) {
          room = item.properties.room;
        }
        if (this._appData.room.id == room) {
          this._appData.object = item;
          $('#containerModalTrello').modal("hide");
          $('#editRoomModal').modal("show");
          $('#editRoomModalClick').click();
        }
        else {
          let domain = window.location.origin
          window.location.href = domain + "/gameevent/" + item.properties.map + '?room=' + room;
        }
        break;

      }
      case "key": {
        Swal.fire({
          title: this.translate.instant('CONTAINER_MODAL_35'),
          text: this.translate.instant('CONTAINER_MODAL_36') + item.param.room + this.translate.instant('CONTAINER_MODAL_39'),
          confirmButtonText: this.translate.instant('CONTAINER_MODAL_23'),
          cancelButtonText: this.translate.instant('CONTAINER_MODAL_37'),
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
        }).then((result) => {
          if (result.dismiss == 'backdrop') { }
          else if (result.dismiss == 'close') { }
          else if (result.dismiss == 'cancel') {
            Swal.fire({
              title: this.translate.instant('CONTAINER_MODAL_38'),
              input: 'text',
              inputAttributes: {
                autocapitalize: 'off'
              },
              showCancelButton: true,
              confirmButtonText: this.translate.instant('SAVE'),
              showLoaderOnConfirm: true,
              preConfirm: (name) => {
                if (name) {
                  item.name = name;
                  this._companyService.getUserContainerRef().doc(item.objectId).set(item.toDB())
                  for (let i = 0; i < this._appData.userEventContainer.length; i++) {
                    if (this._appData.userEventContainer[i].objectId == item.objectId) {
                      this._appData.userEventContainer[i] = item
                    }
                  }
                }
              }
            })
          }
          else {
            let key = this._appData.room.id;
            if (this._appData.room.meeting) {
              key = this._appData.room.father
            }
            if (item.param.room == key) {
              this.closeModal();
              this._appData.object = item;
              $(`#roomMediaControlModal`).modal('show')
              $('#mediaControlChange').click();
            }
            else {
              Swal.fire({ title: this.translate.instant('CONTAINER_MODAL_40'), text: this.translate.instant('CONTAINER_MODAL_41') })
            }
          }
        });
        break;
      }
      case "room": {
        if (this._appData.room.id == item.param.value) {
          this.closeModal();
          $(`#roomMediaControlModal`).modal('show')
          $('#mediaControlChange').click();
        }
        else {
          Swal.fire({ title: this.translate.instant('CONTAINER_MODAL_40'), text: this.translate.instant('CONTAINER_MODAL_41') })
        }
        break
      }
      case "openLink": {//open new page
        this._companyService.openExternalLink(item.param.link, true);
        break
      }
      case "game": {
        let param = item.param;
        let gameActions = param.gameActions;
        gameActions.forEach(a => {
          if (a.kind == 'moveItem') {
            let object = a.objectId;
            let position = a.position
            let rotation = a.rotation;
            this._companyService.getUserRoomItemRef(this._appData.room.id).doc(object).update({ "position": position, "rotation": rotation })

          }
          if (a.kind == 'notification') {
            let link = a.link;
            let recipient = a.recipient;
            let notificationKind = a.notificationKind
            let date = new Date();
            let time = date.getTime();
            let notification = {
              event: this._appData.event.id,
              time: time,
              senderUid: this._appData.instagramUser.uid,
              senderName: this._appData.instagramUser.full_name,
              senderThumbnail: '',
              subject: recipient,
              message: '',
              kind: notificationKind,
              link: link,
              read: false,
              action: '',
              answer: ''
            }
            this._companyService.addRoomNotification(this._appData.room, notification);
          }
        })
        0



        break
      }
      case "avatarChange": {//open inside game
        /*          this.sendIframeMessage({
                    kind:'avatarChange',
                    params:item.param,
                  },'gameFrame');*/
        let date = new Date();
        let time = date.getTime();
        let notification = {
          subject: this._appData.instagramUser.uid,
          avatar: item.param.avatar,
          kind: 'updateUserAvatar',
          room: this._appData.room.id,
          date: time
        }
        this._companyService.addEventNotification(this._appData.event, notification)
        break
      }
      case "insideGame": {//open inside game
        this._appData.param = { link: item.param.link, name: item.name }
        $('#containerModalTrello').modal('hide')
        $('#externalLinkModal').modal('show')
        $('#externalLinkModalClick').click();
        break
      }
      case "embed": {//embending on the stream
        if (!item.param) item.param = { link: '' }
        let link = item.param.link;
        this._appData.param = { link: link, name: item.name }

        if (!link) {
        }
        else {
          Swal.fire({
            title: this.translate.instant('CONTAINER_MODAL_42'),
            text: this.translate.instant('CONTAINER_MODAL_43'),
            confirmButtonText: this.translate.instant('CONTAINER_MODAL_44'),
            cancelButtonText: this.translate.instant('CONTAINER_MODAL_45'),
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
          }).then((result) => {
            if (result.dismiss == 'backdrop') { }
            else if (result.dismiss == 'close') { }
            else if (result.dismiss == 'cancel') {
            }
            else {
              $('#containerModalTrello').modal('hide')
              this._companyService.openExternalLink(item.param.link, true);
            }
          });
        }
        break
      }
      case "modal": {
        $('#containerModalTrello').modal('hide')
        $('#' + item.src).modal("show")
        break;
      }
      case "equip": {
        Swal.fire({
          title: this.translate.instant('CONTAINER_MODAL_46'), text: this.translate.instant('CONTAINER_MODAL_47'), showCloseButton: true,
          confirmButtonText: this.translate.instant('YES'),
          cancelButtomText: this.translate.instant('NO'),
          showCancelButton: true,
        }).then((result) => {
          if (result.value) {
            this.equipItem(item)
          }

        })
        break;
      }
      case "door": {
        let door = new Door();
        door.bagUseItem();
        break;
      }

      case "cellphone": {
        this._appData.toggleCellPhone = true;
        $('#containerModalTrello').modal('hide')
        break;
      }
    }
  }

  public closeModal() {
    $('#containerModal').modal('hide')

  }
  public testLink(link) {
    if (link.indexOf('<iframe') >= 0) {
      let sidx = link.indexOf('src=')
      link = link.substring(sidx + 5)
      let eidx = link.indexOf('"')
      link = link.substring(0, eidx)
      return link;
    }
    else {
      return link;
    }
  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/container/trello-container-modal.ts